import { getCropOutputRect } from './getCropOutputRect';
import { TCropArea } from '../types/TCropArea';

const OUTPUT_BACKGROUND = '#ffffff';
const OUTPUT_MIME_TYPE = 'image/jpeg';
const OUTPUT_QUALITY = 0.8;

const loadImage = (src: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('The selected image could not be read.'));
    image.src = src;
  });

export async function cropImageToDataUrl(src: string, area: TCropArea, maxSize: number): Promise<string> {
  const image = await loadImage(src);
  const { source, size } = getCropOutputRect(area, image.naturalWidth, image.naturalHeight, maxSize);

  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('The selected image could not be processed.');
  }

  context.fillStyle = OUTPUT_BACKGROUND;
  context.fillRect(0, 0, size, size);
  context.drawImage(image, source.x, source.y, source.width, source.height, 0, 0, size, size);

  return canvas.toDataURL(OUTPUT_MIME_TYPE, OUTPUT_QUALITY);
}
